// import { PushNotificationStateType } from '@parent-app/types';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { PushNotificationStateType } from 'src/shared/types/src';

const initialState: PushNotificationStateType = {
    fcmToken: '',
    notificationRemindLaterTime: 0,
    lastFCMTokenUpdateTime: 0
}

const pushNotificationSlice = createSlice({
    name: 'pushNotificationSlice',
    initialState,
    reducers: {
        setFcmToken: (state, action: PayloadAction<{ fcmToken: string }>) => {
            state.fcmToken = action.payload.fcmToken;
        },
        setRemindLaterTime: (state, action: PayloadAction<number>) => {
            state.notificationRemindLaterTime = action.payload;
        },
        setLastFCMTokenUpdateTime: (state, action: PayloadAction<number>) => {
            state.lastFCMTokenUpdateTime = action.payload;
        }
    }
});

export const PushNotificationActions = pushNotificationSlice.actions;
export default pushNotificationSlice.reducer;
